__turbopack_context__.v({
  "BottomWrapper": "_0OgOuW_BottomWrapper",
  "Button": "_0OgOuW_Button",
  "Container": "_0OgOuW_Container",
  "Content": "_0OgOuW_Content",
  "Image": "_0OgOuW_Image",
  "ImageContainer": "_0OgOuW_ImageContainer",
  "Link": "_0OgOuW_Link",
  "Loaded": "_0OgOuW_Loaded",
  "Loader": "_0OgOuW_Loader",
  "Root": "_0OgOuW_Root",
  "Subcategories": "_0OgOuW_Subcategories",
  "Subcategory": "_0OgOuW_Subcategory",
  "Text": "_0OgOuW_Text",
  "Title": "_0OgOuW_Title",
  "placeHolderShimmer": "_0OgOuW_placeHolderShimmer",
});
